import { useCallback, useState } from "react";

const useToggle = (initialValue: boolean = false): [boolean, () => void] => {
  const [value, setValue] = useState(initialValue);
  const toggleValue = useCallback(() => setValue((v) => !v), []);
  return [value, toggleValue];
};

export { useToggle };
